<mat-card>
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>
        <h1>{{ siteNames | join }}</h1>
      </mat-card-title>
      <div>
        <button mat-raised-button color="primary" (click)="edit()">
          <mat-icon>edit</mat-icon>
        </button>
        <app-delete-button (delete)="delete()"></app-delete-button>
      </div>
    </mat-card-title-group>
  </mat-card-header>

  <mat-card-content fxLayout="row" fxLayoutAlign="center center">
    <div class="table-container">
      <table class="main">
        <caption></caption>
        <th></th>
        <tr>
          <td>
            <span class="fa-solid fa-play"></span>
            {{ TITLE + "marketingVideo" | translate }}:
          </td>
          <td>
            <app-embed-video [videoUrl]="data.marketingVideo"></app-embed-video>
          </td>
        </tr>

        <tr>
          <td>
            <span class="fa-solid fa-circle-info"></span>
            {{ TITLE + "introduction" | translate }}:
          </td>
          <td>
            <span class="comma" *ngFor="let d of data.introduction | keyvalue">
              {{ getLangNameByCode(d.key) }}: {{ d.value }}
            </span>
          </td>
        </tr>

        <tr *ngIf="hasKeys(data.tourismServices)">
          <td>
            <span class="fa-solid fa-plane"></span>
            {{ TITLE + "tourismServices" | translate }}:
          </td>
          <td>
            <span *ngFor="let tourismService of data.tourismServices">
              <span *ngFor="let localized of tourismService | keyvalue">
                {{ getLangNameByCode(localized.key) }}:
                {{ localized.value.title }}
                {{ localized.value.description }}
                <img [src]="localized.value.tourismServicePictureId" />
                <br />
              </span>
            </span>
          </td>
        </tr>

        <tr *ngIf="hasKeys(data.promotions)">
          <td>
            <span class="fa-solid fa-tag"></span>
            {{ TITLE + "promotions" | translate }}:
          </td>
          <td>
            <span *ngFor="let promotion of data.promotions">
              <span *ngFor="let localized of promotion | keyvalue">
                {{ getLangNameByCode(localized.key) }}: {{ localized.value }}
                <br />
              </span>
            </span>
          </td>
        </tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
